import React from 'react';

const SafeIcon = ({ icon: IconComponent, className = '', size = 24, ...props }) => {
  if (!IconComponent) {
    console.warn('SafeIcon: No icon component provided');
    return null;
  }

  try {
    return (
      <IconComponent 
        className={className} 
        size={size} 
        {...props}
      />
    );
  } catch (error) {
    console.error('SafeIcon: Error rendering icon:', error);
    return null;
  }
};

export default SafeIcon;